import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function DefaultSort(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="8"
        height="12"
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.929707 5C0.575805 5 0.25675 4.78072 0.121318 4.44442C-0.0141144 4.10811 0.0607463 3.721 0.310993 3.4636L2.93597 0.763604C3.27768 0.412132 3.8317 0.412132 4.1734 0.763604L6.79838 3.4636C7.04863 3.721 7.12349 4.10811 6.98806 4.44442C6.85262 4.78072 6.53357 5 6.17967 5H0.929707Z"
          fill="#8B8B8B"
        />
        <path
          d="M6.17967 7C6.53357 7 6.85262 7.21928 6.98806 7.55558C7.12349 7.89189 7.04863 8.279 6.79838 8.5364L4.1734 11.2364C3.8317 11.5879 3.27768 11.5879 2.93597 11.2364L0.310993 8.5364C0.0607462 8.279 -0.0141144 7.89189 0.121318 7.55558C0.25675 7.21928 0.575805 7 0.929707 7H6.17967Z"
          fill="#8B8B8B"
        />
      </svg>
    </SvgIcon>
  );
}
